import styled from 'styled-components';

export const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  display: block;

  object-fit: ${({ stretch, maintainAspectRatio }) => {
    if (stretch && maintainAspectRatio) return 'cover'; // Fills container, maintains ratio (may crop)
    if (stretch && !maintainAspectRatio) return 'fill';  // Stretches to fill container (may distort)
    if (!stretch && maintainAspectRatio) return 'contain'; // Fits inside container, maintains ratio
    return 'none'; // Displays at native size
  }};
`;